// Add your custom JS here.
class IadTouchEvent
{
    static SWPIE_THRESHOLD = 50

    static SWIPE_LEFT   = 1
    static SWIPE_RIGHT  = 2
    static SWIPE_UP     = 3
    static SWIPE_DOWN   = 4

    constructor(startEvent, endEvent)
    {
        this.startEvent = startEvent
        this.endEvent = endEvent || null
    }

    isSwipeLeft = () => {
        return this.getSwipeDirection() == IadTouchEvent.SWIPE_LEFT
    }

    isSwipeRight = () => {
        return this.getSwipeDirection() == IadTouchEvent.SWIPE_RIGHT
    }

    isSwipeUp = () => {
        return this.getSwipeDirection() == IadTouchEvent.SWIPE_UP
    }

    isSwipeDown = () => {
        return this.getSwipeDirection() == IadTouchEvent.SWIPE_DOWN
    }

    isSwipeBelowThreshold = () => {
        return this.getSwipeDirection() == 'threshold'
    }

    getSwipeDirection = () => {
        let start = this.startEvent
        let end = this.endEvent

        if (!start || !end) {
            return null
        }

        let horizontalDifference = (start.changedTouches ? start.changedTouches[0].screenX - end.changedTouches[0].screenX : start.x - end.x);
        let verticalDifference = (start.changedTouches ? start.changedTouches[0].screenY - end.changedTouches[0].screenY :start.y - end.y);

        if (Math.abs(horizontalDifference) > Math.abs(verticalDifference)) {
            if (horizontalDifference >= IadTouchEvent.SWPIE_THRESHOLD) {
                return IadTouchEvent.SWIPE_LEFT
            } else if (horizontalDifference <= -IadTouchEvent.SWPIE_THRESHOLD) {
                return IadTouchEvent.SWIPE_RIGHT
            } else {
              return 'threshold'
            }

        } else {
            if (verticalDifference >= IadTouchEvent.SWPIE_THRESHOLD) {
                return IadTouchEvent.SWIPE_UP
            } else if (verticalDifference <= -IadTouchEvent.SWPIE_THRESHOLD) {
                return IadTouchEvent.SWIPE_DOWN
            } else {
              return 'threshold'
            }
        }

        return null
    }

    setEndEvent = (endEvent) => {
        this.endEvent = endEvent
    }
}

// item-scroller-nav shizzle
let navIsDown=false;
let navTouchEvent = null;
let indicatorWrapper=document.getElementById('itemSliderNavbar');
let navStartX;

// item-scroller shizzle
let touchIsDown=false;
let thisTouchEvent = null;
let touchableElementWrapper=document.getElementById('itemSliderWrapper');
let touchableElement=document.getElementById('itemSliderTouchable');
let touchableIndicator=document.getElementById('indicator');
let currentMove=0;
let touchableElementItemCount;
let touchableElementItemWidth;
let touchableItemInView;
let moveThreshold;
let touchableIndicatorWidth;
let indicatorWrapperWidth;
let startX;

function setTouchVars() {
  if(!touchableElementWrapper) return;
  touchableElementItemCount=document.querySelectorAll('#itemSliderTouchable > .item').length;
  touchableElementItemWidth=document.querySelectorAll('#itemSliderTouchable > .item')[0].offsetWidth*-1;
  touchableItemInView=Math.floor(touchableElementWrapper.offsetWidth/(touchableElementItemWidth*-1));
  moveThreshold=touchableElementItemCount-touchableItemInView;
  touchableIndicatorWidth=(((document.getElementById('itemSliderNavbar').offsetWidth)-20) / (moveThreshold+1));
  touchableIndicator.style.width=touchableIndicatorWidth+'px';
  indicatorWrapperWidth=indicatorWrapper.offsetWidth;
}

setTouchVars();

if(touchableElement) {
  touchableElement.addEventListener('touchstart', (event) => {
    thisTouchEvent = new IadTouchEvent(event);
    touchIsDown=true;
    startX = event.pageX - touchableElement.offsetLeft;
  });
  touchableElement.addEventListener('mousedown', (event) => {
    thisTouchEvent = new IadTouchEvent(event);
    touchIsDown=true;
    startX = event.pageX - touchableElement.offsetLeft;
  });
  touchableElement.addEventListener('touchend', handleTouch);
  touchableElement.addEventListener('mouseup', handleTouch);
  touchableElement.addEventListener('mouseout', handleTouch);
  touchableElement.addEventListener('mousemove', (e) => {
    if(!touchIsDown) return;
    const x = e.pageX - touchableElement.offsetLeft;
    const walk = (x - startX) / 2;
    dragItemLeft(walk);
  });

  indicatorWrapper.addEventListener('mousedown', (event) => {
    navTouchEvent = new IadTouchEvent(event);
    navIsDown=true;
    navStartX = event.pageX - (indicatorWrapper.offsetLeft);
  });
  indicatorWrapper.addEventListener('mouseup', handleNavTouch);
  indicatorWrapper.addEventListener('mouseout', handleNavTouch);
  indicatorWrapper.addEventListener('mousemove', (e) => {
    if(!navIsDown) return;
    const x = e.pageX - (indicatorWrapper.offsetLeft)+(indicatorWrapperWidth/5);
    const walk = (x - navStartX) / 2;
    dragNavItemLeft(walk);
  });
}

function dragNavItemLeft(walk) {
  touchableIndicator.style.left=(currentMove*touchableIndicatorWidth)+walk+'px';
  // console.log(touchableElement.style.left);
}

function handleNavTouch(event) {
  navIsDown=false;

  if(!navTouchEvent) return;

  navTouchEvent.setEndEvent(event);

  if(navTouchEvent.isSwipeLeft()) {
    if(currentMove > 0) currentMove=currentMove-1;
  }

  if(navTouchEvent.isSwipeRight()) {
    if(currentMove < moveThreshold) currentMove=currentMove+1;
  }

  updateItemLeft();

  navTouchEvent = null;
}

function handleTouch(event) {

  touchIsDown=false;

  if(!thisTouchEvent) return;

  thisTouchEvent.setEndEvent(event);

  if(thisTouchEvent.isSwipeRight()) {
    if(currentMove > 0) currentMove=currentMove-1;
  }

  if(thisTouchEvent.isSwipeLeft()) {
    if(currentMove < moveThreshold) currentMove=currentMove+1;
  }

  updateItemLeft();

  thisTouchEvent = null;
}

function dragItemLeft(walk) {
  touchableElement.style.left=(currentMove*touchableElementItemWidth+10)+walk+'px';
  // console.log(touchableElement.style.left);
}

function updateItemLeft() {
  // console.log('update item left');
  touchableElement.style.left=(currentMove*touchableElementItemWidth)+'px';
  touchableIndicator.style.left=(currentMove*touchableIndicatorWidth+10)+'px';
}

// NAVIGATION SHIZZLE
let navElement=document.getElementById('main-nav');
function setNavScrollStyle() {
  let doc = document.documentElement;
  let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
  if(top > 80) {
    navElement.classList.add('minimise');
  } else {
    navElement.classList.remove('minimise');
  }
}
window.onscroll = (e) => {
  setNavScrollStyle();
}
setNavScrollStyle();

// HOMEPAGE HERO HEIGHT
function setVhVar() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
}
window.addEventListener('orientationchange', function() {
  setVhVar();
  setTouchVars();
});
window.addEventListener('resize', function() {
  setVhVar();
  setTouchVars();
});
setVhVar()

